'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of sleep
 */ const Sleep = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsxs("g", {
                clipPath: "url(#clip0_3427_20496)",
                children: [
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M75.3112 58.6634C59.998 58.6696 47.514 46.1875 47.5089 30.8665C47.5077 27.246 48.1985 23.7874 49.4555 20.6148C49.9676 19.3221 48.722 18.018 47.4118 18.4828C35.675 22.6471 27.2695 33.8528 27.2695 47.023C27.2695 63.7428 40.8162 77.2969 57.5268 77.2969C69.6685 77.2969 80.1396 70.1413 84.958 59.815C85.546 58.5549 84.3718 57.185 83.0365 57.5713C80.5841 58.2814 77.9925 58.6621 75.3119 58.6634H75.3112Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M45.1412 80.3282C50.8971 74.5691 50.8971 65.2317 45.1412 59.4726C39.3852 53.7135 30.053 53.7135 24.2971 59.4726C18.5411 65.2317 18.5411 74.5691 24.2971 80.3282C30.053 86.0873 39.3852 86.0873 45.1412 80.3282Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M40.7381 77.2344C40.5325 77.2344 40.3244 77.1823 40.1338 77.0719L32.8906 72.8926V61.8199C32.8906 61.1506 33.4329 60.6074 34.1024 60.6074C34.7719 60.6074 35.3142 61.15 35.3142 61.8199V71.492L41.3443 74.9713C41.9242 75.3056 42.123 76.047 41.7888 76.6272C41.5644 77.0161 41.1569 77.2344 40.7381 77.2344Z",
                        fill: theme.ds5.asset[assetColor]["100"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M57.3278 28.2829C57.4826 28.8618 58.3032 28.8618 58.4581 28.2829C58.7803 27.0874 59.7094 26.154 60.8955 25.8354L60.9036 25.8329C61.481 25.6773 61.481 24.8581 60.9036 24.7026L60.8955 24.7001C59.7094 24.3814 58.7803 23.4481 58.4581 22.2526C58.3032 21.6736 57.4826 21.6736 57.3278 22.2526C57.0056 23.4481 56.0765 24.3814 54.8904 24.7001L54.8822 24.7026C54.3049 24.8581 54.3049 25.6773 54.8822 25.8329L54.8904 25.8354C56.0809 26.159 57.0106 27.0917 57.3278 28.2829Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M68.1685 34.6997L67.5441 32.3639C67.3892 31.785 66.5686 31.785 66.4138 32.3639L65.7894 34.6997C65.1111 37.2162 63.1552 39.1801 60.6589 39.8513L58.3237 40.4804C57.7463 40.636 57.7463 41.4552 58.3237 41.6107L60.6589 42.2398C63.1652 42.921 65.1211 44.8843 65.7894 47.3914L66.4138 49.7272C66.5686 50.3062 67.3892 50.3062 67.5441 49.7272L68.1685 47.3914C68.8468 44.8749 70.8027 42.911 73.299 42.2398L75.6342 41.6107C76.2116 41.4552 76.2116 40.636 75.6342 40.4804L73.299 39.8513C70.8027 39.1801 68.8468 37.2162 68.1685 34.6997Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    }),
                    /*#__PURE__*/ jsxRuntime.jsx("path", {
                        d: "M78.7086 25.2067C78.2773 26.8137 77.0147 28.0726 75.3967 28.5086L74.6488 28.7086C74.0702 28.8636 74.0702 29.6846 74.6488 29.8396L75.3967 30.0397C77.0147 30.4762 78.2773 31.7351 78.7086 33.3421L78.9117 34.096C79.0672 34.6737 79.8859 34.6737 80.0414 34.096L80.2445 33.3421C80.6821 31.7288 81.9447 30.4699 83.5564 30.0397L84.3043 29.8396C84.8829 29.6846 84.8829 28.8636 84.3043 28.7086L83.5564 28.5086C81.9384 28.072 80.6758 26.8131 80.2445 25.2067L80.0414 24.4528C79.8859 23.8751 79.0672 23.8751 78.9117 24.4528L78.7086 25.2067Z",
                        fill: theme.ds5.asset[assetColor]["500"]
                    })
                ]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_20496",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "66.2456",
                        height: "67.3684",
                        fill: "white",
                        transform: "translate(18.875 18.3867)"
                    })
                })
            })
        ]
    });
};

exports.Sleep = Sleep;
//# sourceMappingURL=Sleep.cjs.map
